"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var lodash_1 = __importDefault(require("lodash"));
var modal_1 = require("ngx-bootstrap/modal");
var constants_1 = require("../../../../constants");
var log_action_shortcut_service_1 = require("../../../../services/log-action-shortcut.service");
var confirmation_modal_component_1 = require("../../modals/confirmation-modal/confirmation-modal.component");
var CustomerConnectLogActionComponent = /** @class */ (function () {
    function CustomerConnectLogActionComponent(logActionShortcutService, bsModalService) {
        this.logActionShortcutService = logActionShortcutService;
        this.bsModalService = bsModalService;
        this.onLogScheduleSubmit = new core_1.EventEmitter();
        this.notesType = this.subAction;
        this.isLogEmail = false;
        this.activity = null;
        this.errorMessage = '';
        // ActionResultSetID  mapped to setID of json AutoAlert/API/activity-results.json
        this.callActionResultSetID = 1;
        this.apptActionResultSetID = 2;
        this.noteActionResultSetID = 3;
        this.emailActionResultSetID = -1;
        this.translateKeys = constants_1.TranslateKeys;
        this.activityActionEnum = constants_1.ActivityActionEnum;
        // models for display
        this.noteObject = {
            call: {
                activityId: this.activityActionEnum.Log_Call,
                description: this.translateKeys.logCallTitleKey,
                resultType: this.callActionResultSetID,
                resultLabelKey: 'logCallResult',
                isCallBoundTypeVisible: true
            },
            note: {
                activityId: this.activityActionEnum.Post_Note,
                description: this.translateKeys.postNotesTitleKey,
                resultType: this.noteActionResultSetID,
                resultLabelKey: 'postNotesResult',
                isCallBoundTypeVisible: false
            },
            email: {
                activityId: this.activityActionEnum.Email_Sent,
                description: this.translateKeys.logEmailSentTitleKey,
                resultType: this.emailActionResultSetID,
                resultLabelKey: 'result',
                isCallBoundTypeVisible: false
            },
            cancelCallActivity: {
                activityId: this.activityActionEnum.Cancel_Call,
                description: this.translateKeys.cancelTitleCallKey,
                resultType: this.emailActionResultSetID,
                resultLabelKey: 'result',
                isCallBoundTypeVisible: false
            },
            cancelApptActivity: {
                activityId: this.activityActionEnum.Cancel_Appt,
                description: this.translateKeys.cancelTitleApptKey,
                resultType: this.emailActionResultSetID,
                resultLabelKey: 'result',
                isCallBoundTypeVisible: false
            },
            completeCallActivity: {
                activityId: this.activityActionEnum.Phone_Call_Completed,
                description: this.translateKeys.completeTitleCallKey,
                resultType: this.callActionResultSetID,
                resultLabelKey: 'logCallResult',
                isCallBoundTypeVisible: false
            },
            completeApptActivity: {
                activityId: this.activityActionEnum.Appointment_Completed,
                description: this.translateKeys.completeTitleApptKey,
                resultType: this.apptActionResultSetID,
                resultLabelKey: 'resultOfAppointment',
                isCallBoundTypeVisible: false
            }
        };
        // model for UI
        this.activityResultsList = {};
        this.activityResultsListColumn1 = [];
        this.activityResultsListColumn2 = [];
        this.status = { opened: false };
        this.model = { notes: '', resultID: -1, callBoundType: null, setScheduleAppt: false };
    }
    CustomerConnectLogActionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logActionShortcutService.$logShortcutAction.subscribe(function (activityActionEnum) {
            if (activityActionEnum) {
                _this.notesType = activityActionEnum;
                _this.handleNotesTypeChange();
            }
        });
    };
    // set default selection and get drop down list
    CustomerConnectLogActionComponent.prototype.setActivityResults = function () {
        var _this = this;
        this.activityResultsList = constants_1.ActivityResultDescriptors.filter(function (value) { return value.setID === _this.currentNoteType.resultType; });
        this.activityResultsListColumn1 = constants_1.ActivityResultDescriptors.filter(function (value) {
            return value.setID === _this.currentNoteType.resultType && value.column === 1;
        });
        this.activityResultsListColumn2 = constants_1.ActivityResultDescriptors.filter(function (value) {
            return value.setID === _this.currentNoteType.resultType && value.column === 2;
        });
        if (this.permissions) {
            this.removeFromActivityResults(this.permissions.editMarkAsSold, 7);
            this.removeFromActivityResults(this.permissions.editMarkAsSold, 11);
            this.removeFromActivityResults(this.permissions.editMarkAsSold, 23);
            this.removeFromActivityResults(this.permissions.editMarkAsPaidOff, 33);
            this.removeFromActivityResults(this.permissions.editMarkAsNotOwn, 28);
            this.removeFromActivityResults(this.permissions.editMarkAsNotOwn, 31);
            this.removeFromActivityResults(this.isEuroLite && this.currentNoteType === this.noteObject.note, 29);
        }
        this.model.resultID = -1;
    };
    CustomerConnectLogActionComponent.prototype.removeFromActivityResults = function (hasPermission, activityResultId) {
        if (!hasPermission) {
            var index = lodash_1.default.findIndex(this.activityResultsListColumn1, function (item) { return item.activityResultID === activityResultId; });
            if (index > -1) {
                this.activityResultsListColumn1.splice(index, 1);
            }
            var index2 = lodash_1.default.findIndex(this.activityResultsListColumn2, function (item) { return item.activityResultID === activityResultId; });
            if (index2 > -1) {
                this.activityResultsListColumn2.splice(index2, 1);
            }
        }
    };
    CustomerConnectLogActionComponent.prototype.onTypeOfCallSelect = function (data) {
        this.model.callBoundType = data;
    };
    CustomerConnectLogActionComponent.prototype.ngOnChanges = function (changes) {
        if (changes.isReset && !changes.isReset.isFirstChange()) {
            this.model = { notes: '', resultID: -1, callBoundType: null, setScheduleAppt: false };
            this.errorMessage = '';
        }
        if (changes.isError && !changes.isError.isFirstChange()) {
            this.errorMessage = 'postnotesResultErrorMsg';
        }
        if (this.subAction && this.dialogParams) {
            this.opportunityId = this.dialogParams.opportunityId;
            this.dealerId = this.dialogParams.dealerId;
            this.notesType = this.subAction;
            if (this.dialogParams.activityObject) {
                this.activity = this.dialogParams.activityObject;
            }
        }
        this.handleNotesTypeChange();
    };
    CustomerConnectLogActionComponent.prototype.handleNotesTypeChange = function () {
        switch (this.notesType) {
            case constants_1.ActivityActionEnum.Post_Note:
                this.currentNoteType = this.noteObject.note;
                this.dialogTitle = this.currentNoteType.description;
                this.setActivityResults();
                break;
            case constants_1.ActivityActionEnum.Log_Call:
                this.currentNoteType = this.noteObject.call;
                this.dialogTitle = this.currentNoteType.description;
                this.setActivityResults();
                break;
            case constants_1.ActivityActionEnum.Email_Sent:
                this.currentNoteType = this.noteObject.email;
                this.dialogTitle = this.currentNoteType.description;
                this.isLogEmail = true;
                break;
            case constants_1.ActivityActionEnum.Cancel_Call:
                this.currentNoteType = this.noteObject.cancelCallActivity;
                this.dialogTitle = this.currentNoteType.description;
                this.isLogEmail = true;
                break;
            case constants_1.ActivityActionEnum.Cancel_Appt:
                this.currentNoteType = this.noteObject.cancelApptActivity;
                this.dialogTitle = this.currentNoteType.description;
                this.isLogEmail = true;
                break;
            case constants_1.ActivityActionEnum.Phone_Call_Completed:
                this.currentNoteType = this.noteObject.completeCallActivity;
                this.dialogTitle = this.currentNoteType.description;
                this.setActivityResults();
                break;
            case constants_1.ActivityActionEnum.Appointment_Completed:
                this.currentNoteType = this.noteObject.completeApptActivity;
                this.dialogTitle = this.currentNoteType.description;
                this.setActivityResults();
                break;
        }
    };
    CustomerConnectLogActionComponent.prototype.onLogActivityCompleteMarkAsSold = function () {
        var _this = this;
        var modal = this.bsModalService.show(confirmation_modal_component_1.ConfirmationModalComponent, {
            animated: true,
            initialState: {
                title: 'pleaseConfirm',
                message: 'euroliteMarkAsSoldVehiclePaidOffNoLongerOwnsPrompt',
                submitButtonText: 'confirm'
            }
        });
        modal.content.onSubmit.subscribe(function () {
            _this.onPostSubmit();
        });
    };
    CustomerConnectLogActionComponent.prototype.onSubmit = function () {
        if (!this.isEuroLite) {
            this.onPostSubmit();
            return;
        }
        else {
            if (this.model.resultID === constants_1.ActivityResults.phoneCall.soldVehicle
                || this.model.resultID === constants_1.ActivityResults.note.soldVehicle
                || this.model.resultID === constants_1.ActivityResults.phoneCall.noLongerOwns
                || this.model.resultID === constants_1.ActivityResults.note.noLongerOwns
                || this.model.resultID === constants_1.ActivityResults.phoneCall.vehiclePaidOff
                || this.model.resultID === constants_1.ActivityResults.note.vehiclePaidOff) {
                this.onLogActivityCompleteMarkAsSold();
            }
            else {
                this.onPostSubmit();
            }
        }
    };
    CustomerConnectLogActionComponent.prototype.onPostSubmit = function () {
        if (this.model.resultID <= -1) {
            switch (this.notesType) {
                case constants_1.ActivityActionEnum.Post_Note:
                case constants_1.ActivityActionEnum.Log_Call:
                case constants_1.ActivityActionEnum.Phone_Call_Completed:
                case constants_1.ActivityActionEnum.Appointment_Completed:
                    this.errorMessage = 'postnotesResultErrorMsg';
                    this.onLogScheduleSubmit.emit(null); // bubble event to parent
                    return;
            }
        }
        var recordId = null;
        if (this.activity) {
            recordId = this.activity.activityId;
        }
        var activity;
        // model to save
        if (this.notesType === constants_1.ActivityActionEnum.Post_Note) {
            activity = {
                entityID: this.opportunityId,
                activityActionID: this.currentNoteType.activityId,
                notes: this.model.notes,
                resultID: this.model.resultID,
                activityId: recordId,
                isFollowUpScheduleAppt: this.model.setScheduleAppt
            };
        }
        else if (this.notesType === constants_1.ActivityActionEnum.Log_Call) {
            activity = {
                entityID: this.opportunityId,
                activityActionID: this.currentNoteType.activityId,
                notes: this.model.notes,
                resultID: this.model.resultID,
                activityId: recordId,
                activityActionSubTypeID: this.model.callBoundType,
                isFollowUpScheduleAppt: this.model.setScheduleAppt
            };
        }
        if (!activity) {
            throw new Error('No activity to log, notesType not equal to Post_Note (1) or Log_Call (2)');
        }
        if (!activity.notes) {
            activity.notes = '';
        }
        if (this.dialogParams.uid) {
            activity.uid = this.dialogParams.uid;
        }
        if (activity.resultID === -1) {
            activity.resultID = null;
        }
        // fire event with activity that needs to be submitted
        this.onLogScheduleSubmit.emit(activity);
        this.resetUI();
    };
    CustomerConnectLogActionComponent.prototype.onCancel = function () {
        if (this.dialogParams.uid) {
            this.onLogScheduleSubmit.emit({ uid: this.dialogParams.uid, status: 'cancel' });
        }
        else {
            this.onLogScheduleSubmit.emit('cancel');
        }
        this.resetUI();
    };
    CustomerConnectLogActionComponent.prototype.resetUI = function () {
        this.status = { opened: false };
        this.model = { notes: '', resultID: -1, callBoundType: this.model.callBoundType, setScheduleAppt: false };
        this.model.setScheduleAppt = false;
        this.errorMessage = '';
    };
    return CustomerConnectLogActionComponent;
}());
exports.CustomerConnectLogActionComponent = CustomerConnectLogActionComponent;
